<template>
    <section class="section__body">

        <TabsControl
            class="mb__12"
            :list="filterTypesList"
            v-model="activeType"
            v-if="false"
        />

        <!--- Navigation --->
        <UnitsList_navigation />

        <!--- Container --->
        <section class="selected__container plr__12 pb__12" ref="list_container">

            <DynamicScroller
                ref="list"
                class="list dynamic-scroller-list-units"
                :items="unitsAndGroups"
                :key-field="'xid'"
                :min-item-size="44"
                :buffer="600"
            >
                <template #before>
                    <!-- start -->
                </template>

                <template v-slot="{ item, index, active }">
                    <DynamicScrollerItem
                        :item="item"
                        :active="active"
                        :size-dependencies="[]"
                        :data-index="index"
                        :data-active="active"
                    >
<!--                        :class="item.type == 'group' ? 'list-units-scroller-group-height' : 'list-units-scroller-item-height'"-->
                        <component
                            :is="'UnitsList_'+item.type"
                            v-bind="item"
                            v-model="openIds"
                        />
                    </DynamicScrollerItem>
                </template>

                <template #after>
                    <!--  end -->
                    <SectionLoading v-if="!ready || (ready && !isUnitsLiteLoad)"/>
                    <section class="section section_type_loader loader loader_status_active"
                             v-show="isUnitsLiteLoad && !filteredUnitsIds.length"
                    >
                        <span class="loader__text">{{ $t('text.No data') }}</span>
                    </section>
                </template>
            </DynamicScroller>

        </section>
    </section>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import {computed, defineAsyncComponent} from "vue";

    import UnitsList_navigation from "@/components/units/UnitsList_navigation.vue";
    import {arrayFilter_OnlyUnique} from "@/lib/lib";
    import consts from "@/consts";
    const dmsFieldsFilter = ['leg_number_','customer_code_','driver_code_','container_number_','customer_work_order_reference_', 'chassis_number_']

    //import TabsControl from "@/components/_base/TabsControl";

    export default {
        name: "UnitsList",
        mixins: [],
        components: {
            // VueAutoVirtualScrollList,
            TabsControl: defineAsyncComponent(() => import("@/components/_base/TabsControl.vue")),
            UnitsList_navigation,


            UnitsList_group: defineAsyncComponent(() => consts.app.$isIntuit
                ? import("@/components/units/list-item-types/UnitsList_group.vue")
                : import("@/components/units/list-item-types/UnitsList_group.vue")
            ),
            UnitsList_unit: defineAsyncComponent(() => consts.app.$isIntuit
                ? import("@/components/units/list-item-types/UnitsList_unit.intuit.vue")
                : import("@/components/units/list-item-types/UnitsList_unit.prometheus.vue")
            ),
            UnitsList_unit_xlink: defineAsyncComponent(() => consts.app.$isIntuit
                ? import("@/components/units/list-item-types/hw_type/UnitsList_unit_xlink.intuit.vue")
                : import("@/components/units/list-item-types/UnitsList_unit.prometheus.vue")
            ),
            UnitsList_unit_xpower: defineAsyncComponent(() => consts.app.$isIntuit
                ? import("@/components/units/list-item-types/hw_type/UnitsList_unit_xpower.intuit.vue")
                : import("@/components/units/list-item-types/UnitsList_unit.prometheus.vue")
            ),
            UnitsList_unit_ble_gateway: defineAsyncComponent(() => consts.app.$isIntuit
                ? import("@/components/units/list-item-types/UnitsList_group.vue")
                : import("@/components/units/list-item-types/type/UnitsList_unit_ble_gateway.vue")
            ),
            UnitsList_unit_ble_tag: defineAsyncComponent(() => consts.app.$isIntuit
                ? import("@/components/units/list-item-types/hw_type/UnitsList_unit_xtag.intuit.vue")
                : import("@/components/units/list-item-types/type/UnitsList_unit_ble_tag.vue")
            ),
            UnitsList_unit_xtag: defineAsyncComponent(() => consts.app.$isIntuit
                ? import("@/components/units/list-item-types/hw_type/UnitsList_unit_xtag.intuit.vue")
                : import("@/components/units/list-item-types/type/UnitsList_unit_ble_tag.vue")
            ),
        },
        data() {
            return {
                ready: false,
                interval: null,
                activeType: 'units',
                openIds: [],
            }
        },
        provide(){
            return {
                filteredUnitsIds: computed(() => this.filteredUnitsIds)
            }
        },
        computed: {
            ...mapGetters([
                "getUnits",
                "getUnitsByIds",
                "getUnitsByParentId",
                "getUnitsGroups",
                "getUnitsGroupsByIds",
                "getUnitsGroupsOnMap",

                "getUnitsIdsIsActive",
                "getUnitsIdsIsNotActive",
                "getUnitsIdsIsMoving",
                "getUnitsIdsIsParked",
                "getUnitsIdsIsIgnitionOn",

                "getVideoStatusesByUnitsIds",
                "getUnitsLmsgs",
                "getUnitsLmsgsByIds",
                "getAppointments",

                "isUnitsLiteLoad",

                "getTrandataDmsByDriverCode",
                "getTrandataDms",
            ]),
            filterTypesList() { //ToDo fix
                return [
                    {name: this.$t('text.Units'), value: 'units'},
                    {name: this.$t('text.Groups'), value: 'group'}
                ]
            },
            unit() {
                return this.getUnitsByIds[this.activeUnitId]
            },
            unitsIdsHasGeozone() {
                return this.getUnitsLmsgs
                    .filter(lmsg => lmsg?.geozone?.length)
                    .map(lmsg => lmsg.object_id)
            },
            unitsIdsHasDriver() {
                let dateNow = (Date.now() / 1000)
                return this.getAppointments
                    .filter(a => a?.driver_id && dateNow > a?.time_appointment && (!a?.time_removed || (a?.time_removed > dateNow)))
                    .map(a => a.unit_id)
                    .filter(arrayFilter_OnlyUnique)
            },
            unitsIdsByDriverCode() {
                return this.getUnits
                    .filter(u => u?.dms_driver_code)
                    .reduce((out, unit) => {
                        out[unit.dms_driver_code] = unit.id
                        return out;
                    }, {})
            },
            trandataDmsForFilter() {
                return this.getTrandataDms
                    .map(dms => {
                        let unit_id = this.unitsIdsByDriverCode[dms.driver_code]
                        let filterValues = dmsFieldsFilter.map(f => dms[f]).filter(v => v)
                        return {unit_id, filterValues, id: dms.id, driver_code: dms.driver_code}
                    })
            },
            activeUnitId(){
                return !this.ready ? null : this.routeFilter.unitId || null
            },
            activeParentUnitId() {
                return this.unit?.parent__id
            },
            units_length(){
                return this.getUnits.length
            },
            sortedUnitsIds() {
                let units = this.getUnits.map(u => {
                    let id = u.id
                    let sort = 1
                    if ([+this.activeParentUnitId, +this.activeUnitId].includes(id)) {
                        sort = 0
                    } else
                    if(this.getUnitsIdsIsMoving?.includes(id) && this.getUnitsIdsIsActive?.includes(id)) {
                        //
                    } else
                    if (this.getUnitsIdsIsParked?.includes(id) && this.getUnitsIdsIsActive?.includes(id)){
                        sort = 2
                    } else {
                        sort = 3
                    }
                    if(u.hw_type == 'xtag') {
                        sort = 4
                    }
                    return {id, sort, name_: u.name_}
                })

                units.sort((a, b) => {
                    return a.sort - b.sort
                })
                return units.map(u => u.id)
            },
            filteredUnitsIds() {
                let queryFilter = this.routeQueryFilter
                let routeFilter = this.routeFilter

                let units = this.getUnits//.filter(u => !u.parent__id);
                    // .filter(u => u?.access_right >= accessRight.read)
                if(routeFilter.groupId) {
                    let unitsInGroup = this.getUnitsGroupsByIds[routeFilter.groupId]?.units || []
                    units = units.filter(u => unitsInGroup.includes(u.id))
                }
                //ToDo fix ???
                if(this.getUnitsGroupsOnMap?.length) {
                    let groupUnits = this.getUnitsGroupsOnMap
                        .map(id => this.getUnitsGroupsByIds[id]?.units || [])
                        .flat()
                        .filter(arrayFilter_OnlyUnique)

                    units = units.filter(u => groupUnits.includes(u.id))
                }
                if(queryFilter.xtype) {
                    units = units.filter(u => u.xtype === queryFilter.xtype)
                }
                if(queryFilter.type) {
                    units = units.filter(u => u.type === queryFilter.type)
                }
                if(queryFilter.camera) {
                    units = units.filter(u =>
                        queryFilter.camera === 'all' ? u.video : this.getVideoStatusesByUnitsIds[u.id]?.status === queryFilter.camera
                    )
                }
                if (queryFilter.name) {
                    let name = queryFilter.name?.toLocaleLowerCase()
                    let search = !queryFilter.search ? [] : (Array.isArray(queryFilter.search) ? queryFilter.search : [queryFilter.search])

                    let includeName = !search.length || search.includes('name')
                    let includeImei = !search.length || search.includes('imei')
                    let includeCameraId = !search.length || search.includes('cameraId')
                    let includeDms = !search.length || search.includes('dms')
                    let includeCameraType = !search.length || search.includes('cameraType')
                    let includeDeviceType = !search.length || search.includes('deviceType')

                    let nameIds = !includeName ? [] : units
                        .filter(u => !!u.name_?.includes(name))
                        .map(u => u.id)

                    let cameraTypeIds = !includeCameraType ? [] : units
                        .filter(u => u.camera_type_?.includes(name))
                        .map(u => u.id)

                    let deviceTypeIds = !includeDeviceType ? [] : units
                        .filter(u => u.hw_type_?.includes(name))
                        .map(u => u.id)

                    let imeiIds = !includeImei ? [] : units
                        .filter(u => u.hw_id_?.includes(name))
                        .map(u => u.id)

                    let cameraIdIds = !includeCameraId ? [] : units
                        .filter(u => u.camera_id_?.includes(name))
                        .map(u => u.id)

                    let dmsIds = !includeDms ? [] : this.trandataDmsForFilter
                        .filter(dms => dms.filterValues.find(value => value.includes(name)))
                        .map(dms => {
                            if(!dms?.driver_code) {
                                console.warn('Search - DMS ID:' + dms?.id + ' / Error - Driver Code Empty');
                            } else
                            if(!dms.unit_id) {
                                console.warn('Search - DMS ID:' + dms?.id + ' / Driver Code: ' + dms.driver_code + ' / Error - Unit Not Found');
                            }
                            return dms.unit_id
                        }).filter(v=>v).filter(arrayFilter_OnlyUnique)

                    let ids = [...nameIds, ...imeiIds, ...cameraIdIds, ...dmsIds, ...cameraTypeIds, ...deviceTypeIds]
                    units = units.filter(u => ids.includes(u.id))
                }
                if (queryFilter.signal) {
                    let ids =
                        (queryFilter.signal === 'on') ? this.getUnitsIdsIsActive :
                        (queryFilter.signal === 'off') ? this.getUnitsIdsIsNotActive : []
                    units = units.filter(u => ids.includes(u.id))
                }
                if (queryFilter.movement) {
                    let ids =
                        (queryFilter.movement === 'moving') ? this.getUnitsIdsIsMoving :
                        (queryFilter.movement === 'stopped') ? this.getUnitsIdsIsParked :
                        (queryFilter.movement === 'ignition') ? this.getUnitsIdsIsIgnitionOn : []
                    units = units.filter(u => ids.includes(u.id))
                }
                if (queryFilter.other) {
                    let ids =
                        (queryFilter.other === 'geozone') ? this.unitsIdsHasGeozone :
                        (queryFilter.other === 'driver') ? this.unitsIdsHasDriver : []
                    units = units.filter(u => ids.includes(u.id))
                }
                if (queryFilter.cargo) {
                    let hasCargo = (queryFilter.cargo === 'loaded')
                    units = units.filter(u => u.type === 'chassis' && (this.getUnitsLmsgsByIds[u.id]?.chassis?.hasCargo === true) === hasCargo)
                }

                let paretntsIds = units.filter(u => u.parent__id).map(u => u.parent__id)
                let unitIds = units.filter(u => !u.parent__id).map(u => u.id)

                return [...new Set([...unitIds, ...paretntsIds])]
            },
            unitsGroupsFiltered(){
                return this.getUnitsGroups.reduce((groupsFiltered, g) => {
                    let units = g.units.filter(id => {
                        return this.filteredUnitsIds.includes(id)
                    })
                    groupsFiltered.push({
                        ...g,
                        units: units,
                    })
                    return groupsFiltered
                }, [])
            },
            unitsAndGroups(){
                if(!this.ready) return []

                let groupId = -1
                let units = this.sortedUnitsIds
                    .filter(uId => this.filteredUnitsIds.includes(uId))
                    .map(uId => {
                        let unit = this.getUnitsByIds[uId]
                        let type = this.$isPrometheus ? unit?.type : unit?.hw_type
                        type = this.$consts.unitsList.useTypeForTemplate.includes(type) ? 'unit_'+type : 'unit'

                        let subUnits = (this.openIds.includes(uId) ? (this.getUnitsByParentId[uId] || []) : [])
                            .map(sUid => {
                                let subUnit = this.getUnitsByIds[sUid]
                                let subUnitType = this.$isPrometheus ? (subUnit?.hw_type == 'xtag' ? subUnit?.hw_type : subUnit?.type) : subUnit?.hw_type
                                subUnitType = this.$consts.unitsList.useTypeForTemplate.includes(subUnitType) ? 'unit_'+subUnitType : 'unit'
                                return {xid: `${groupId}-${uId}-${sUid}`, groupId, type: subUnitType, unitId: sUid}
                            })

                        return [
                            {xid: `${groupId}-${uId}`, groupId, type, unitId: uId},
                            ...subUnits,
                        ]
                    })
                    .flat()

                let count = this.sortedUnitsIds.length
                if (count != this.filteredUnitsIds.length) count = this.filteredUnitsIds.length+'/'+count

                return [
                    {xid: `${groupId}`, groupId, type: 'group', title: this.$t('text.Units'), count},
                    ...units,
                ]
            }
        },
        methods: {
            ...mapActions([
                "fetchUnits",
            ]),
        },
        created() {
            //if(this.$isDevelopment) console.log('UnitsList created')
        },
        mounted(){
            //if(this.$isDevelopment) console.log('UnitsList mounted')
            this.$nextTick().then(() => {this.ready = true})
            //setTimeout(() => {this.ready = true;}, 500)
        },
        updated() {
            //if(this.$isDevelopment) console.log('UnitsList updated'
            //     // , this.unitsGroupsFilteredWithSize.filter(g => { return g.size>44+12 }).map(g => g.id)
            //     // , this.unitsGroupsWithSize.filter(g => { return g.size>44+12 }).map(g => g.id)
            // )
        },
        activated() {
            // this.$nextTick().then(() => {this.ready = true})
            setTimeout(() => this.ready = true, this.$consts.timeoutReadyComponent)
        },
        deactivated() {
            this.ready = false
        },
    }
</script>

<style lang="scss" scoped>
.selected__container {
    height: 100%;
    overflow: hidden;
}
.list {
    background: var(--units-list-bg);
}
</style>